/*
 * - Definitions for Dashboard queries
 */

import DashboardService from './service';
import { GetRegulatorHelpRequestsPayload, GetRegulatorHelpRequestsResponse, GetUserRequestsResponse } from './types';

export const DASHBOARD_QUERY_KEYS = {
  GET_DASHBOARD: 'GET_DASHBOARD',
  GET_REGULATOR_HELP_REQUESTS: 'GET_REGULATOR_HELP_REQUESTS',
};

export class DashboardQueries {
  public static readonly getUserRequests = async (archived: boolean): Promise<GetUserRequestsResponse> => {
    const data: GetUserRequestsResponse = await DashboardService.getUserRequests(archived);

    return data;
  };

  public static readonly getRegulatorHelpRequests = async (
    payload: GetRegulatorHelpRequestsPayload
  ): Promise<GetRegulatorHelpRequestsResponse> => {
    const data: GetRegulatorHelpRequestsResponse = await DashboardService.getRegulatorHelpRequests(payload);

    return data;
  };
}
